import { render, staticRenderFns } from "./treeCateCard.vue?vue&type=template&id=023fb226&scoped=true"
import script from "./treeCateCard.vue?vue&type=script&lang=js"
export * from "./treeCateCard.vue?vue&type=script&lang=js"
import style0 from "./treeCateCard.vue?vue&type=style&index=0&id=023fb226&prod&lang=scss"
import style1 from "./treecatecard.scss?vue&type=style&index=1&id=023fb226&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023fb226",
  null
  
)

export default component.exports